import { ILocationForList } from "@services/locations";
import {
  ActionAddNewLocation,
  ActionDeleteLocation,
  ActionEditLocationType as ActionEditLocation,
  ActionSetLocations,
  ActionTypesLocationsE,
} from "./actionTypes";

export const setLocations = (
  locations: ILocationForList[]
): ActionSetLocations => {
  return {
    type: ActionTypesLocationsE.SET_LOCATIONS,
    payload: locations,
  };
};

export const addNewLocation = (
  location: ILocationForList
): ActionAddNewLocation => {
  return {
    type: ActionTypesLocationsE.ADD_NEW_LOCATION,
    payload: location,
  };
};

export const deleteLocation = (id: string): ActionDeleteLocation => {
  return {
    type: ActionTypesLocationsE.DELETE_LOCATION,
    payload: id,
  };
};

export const editLocation = (
  location: ILocationForList
): ActionEditLocation => {
  return {
    type: ActionTypesLocationsE.EDIT_LOCATION,
    payload: location,
  };
};
